import { createFileRoute, lazyRouteComponent } from '@tanstack/react-router';
import { guardSection } from '../../shell/guard.ts';

// Leads area (T30, spec F11). Leads-only data (constitution §6.4): the guard sends everyone but
// owner, supervisor and lead to their own page before any Leads code is fetched, because every
// Leads screen is a lazy chunk loaded only after this guard passes.
export const Route = createFileRoute('/_authed/leads')({
  beforeLoad: guardSection('/leads'),
  component: lazyRouteComponent(() => import('../../features/leads/screens.tsx'), 'LeadsLayout'),
});
